import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg,
  Circle as _Circle
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(_Circle, { cx: "8", cy: "8", r: "6", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M18.09 10.37A6 6 0 1 1 10.34 18", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M7 6h1v4", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m16.71 13.88.7.71-2.82 2.82", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Coins";
const Coins = memo(themed(Icon));
export {
  Coins
};
//# sourceMappingURL=coins.js.map
